import { OpportunityDetail } from './OpportunityDetail';

// The opportunity page the grids open, on the deal in ?opportunityId=, or a new one without it.
export function OpportunityMainSample() {
  return <OpportunityDetail queryParameterName="opportunityId" />;
}
